<template>
<!-- 常见问题及解决方案 -->
  <div class="content">
    <!-- header -->
    <div class="con_header">
      <span class="header_title">常见问题及解决方案</span>
      <el-input v-model="searchValue" placeholder="按照问题描述搜索" size="small" style="width:250px">
        <template #suffix>
            <i class="el-input__icon el-icon-search" @click="search"></i>
        </template>
      </el-input>
    </div>
    <!-- main -->
    <div class="con_main">
      <div class="con_content" v-for="(item,index) in questionList" :key="index">
        <div class="queston">
          <div class="icon">Q</div>
          <div class="ques_content">{{item.question}}</div>
        </div>
        <div class="queston">
          <div><div class="icon answer_icon">A</div></div>
          <div class="answer_content">
            {{item.answer}}
          </div>
        </div>
      </div>
    </div>
    <!-- pagination -->
    <div class="pagination">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="nowPage"
        :page-size="4"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { queryQuestionAnswerByConditions } from '@/api/console/supportServices.js'
export default {
  data() {
    return {
      searchValue: '',//搜索内容
      nowPage: 1, //当前页
      total: 0,
      questionList: [],
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let param = {
        question: this.searchValue,
        nowPage: this.nowPage,
        pageSize: 4
      }
      queryQuestionAnswerByConditions(param).then(res=> {
        this.questionList = res.data.list;
        this.total = res.data.total;
      })
    },
    search() {
      this.getData();
    },
    handleCurrentChange(val) {
      this.nowPage = val;
      this.getData();
    }
  },
}
</script>

<style lang="scss" scoped="scoped">
.content {
  padding: 20px;
  margin-top: 20px;
  border: 1px solid #E5E5E5;
  .con_header {
    .header_title {
      color: #4F4F4F;
    }
    .el-input {
      float: right;
    }
  }
  .con_main {
    margin-top: 20px;
    .con_content {
      padding-bottom: 10px;
      .queston {
        display: flex;
        margin-bottom: 15px;
        line-height: 32px;
        .icon {
          width: 32px;
          height: 32px;
          margin-right: 20px;
          background-color: rgba(80, 125, 241, 1);
          font-size: 12px;
          color: #fff;
          text-align: center;
        }
        .ques_content {
          font-size: 16px;
          color: #4F4F4F;
        }
        .answer_icon {
          background-color: rgba(233, 239, 255, 1);
          color: #2A2A2A;
        }
        .answer_content {
          font-size: 14px;
          color: #6E6E6E;
        }
      }
    }
  }
  .pagination {
    margin-top: 50px;
    text-align: center;
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #537EEE;
      color: #fff;
    }
  }
}
</style>